import CollegeChat from "../images/CollegeChat.png";
import VKweldingProject from "../images/VKweldingProject.png";
import MovieMind from "../images/MovieMind.png";
import findFake from "../images/findFake.png";
import CommentFeel from "../images/CommentFeel.png";
import StatWizard from "../images/statWizard.png";
import linuxShell from "../images/linuxShell.png";
import OmicsUnveil  from "../images/OmicsUnveil .png";
import TaxiATIIITD from "../images/TaxiATIIITD.png";
import BioSync from "../images/BioSync.jpg";
import stockSenseAI from "../images/stockSenseAI.png";
import MediBotAI from "../images/MediBotAI.png";
import DishDecodeAI from "../images/IMG_20250102_204202.jpg"
import NatwestLogo from "../images/NATWEST logo.png"
import NatwestInternCertificate from "../images/NatwestInternCertificate.png"

// Git checkout main
// Make whatever changes you want to do
// Git add .
// Git commit -m "Commit message"
// Git push origin main

// npm run deploy

export const Bio = {
  name: "Aniket Panchal",

  roles: [
    "Full Stack Developer",
    "NLP enthusiast",
    "ML Engineer",
    "Programmer",
    "Human",
  ],
  description:
  "I'm a skilled full stack developer experienced in web development, machine learning, and data science. I'm proficient in Python, C++, JavaScript, and Java, with expertise in React, Node.js, Express, Django, TensorFlow, and sklearn. I've worked on diverse projects, focusing on scalable solutions for real-world problems. Let's collaborate and bring our ideas to life!"

  ,github: "https://github.com/Aniket2021448",
  leetcode: "https://leetcode.com/u/Aniket21448/",
  resume:
    "https://drive.google.com/file/d/1__Oa5UzWL0j3bwRLQZv9SdJf563f581f/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
  twitter: "/",
  insta: "https://www.instagram.com/menos_sintiendo/",
  facebook: "/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        id: 0,
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        id: 0,
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        id: 0,
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        id: 0,
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        id: 0,
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        id: 0,
        name: "Tailwind CSS",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjDE5y0tK_-uaMB18FrU-jPBBlUBv51CWUzt_baeBC1Q&s",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        id: 0,
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        id: 0,
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        id: 0,
        name: "Django",
        image:
          "https://www.svgrepo.com/show/353657/django-icon.svg",
      },

      {
        id: 0,
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        id: 0,
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },

      {
        id: 0,
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        id: 0,
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Machine Learning and NLP",
    skills: [
      {
        id: 0,
        name: "Streamlit",
        image:
          "https://raw.githubusercontent.com/github/explore/968d1eb8fb6b704c6be917f0000283face4f33ee/topics/streamlit/streamlit.png",
      },

      {
        id: 0,
        name: "openCV",
        image:
          "https://w7.pngwing.com/pngs/978/465/png-transparent-learning-opencv-computer-vision-machine-learning-c-robotics-text-computer-logo-thumbnail.png",
      },
      
      {
        id: 0,
        name: "tensorflow",
        image:
          "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
      },
      {
        id: 0,
        name: "Matplotlib",
        image:
          "https://seeklogo.com/images/M/matplotlib-logo-7676870AC0-seeklogo.com.png",
      },
      {
        id: 0,
        name: "NLTK",
        image:
          "https://camo.githubusercontent.com/c7dce5e577931c20e167f90ef6ba33b4c9672d38268a6d2d1ffee3174b138c39/68747470733a2f2f696d616765732e73717561726573706163652d63646e2e636f6d2f636f6e74656e742f76312f3564393666616631333364303730343738363434313064322f313539353438373236313233352d39545730574f3537355235524338314a4b4a45352f4e4c544b2b507974686f6e2b5061636b616765",
      },
      {
        id: 0,
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        id: 0,
        name: "Sklearn",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      },
      {
        id: 0,
        name: "Jupyter labs",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        id: 0,
        name: "Hugging face",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmXiuVO9AEQIV0AiXH9JRYnRqmXQLU1eRaVxcBBDicMA&s",
      },
      {
        id: 0,
        name: "Transformers",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9iaFtGBTL4muPU5pFbZQWKgdbnEVf78ytK9cCEaQQ9dYfu02HWtpmIxvn9QQ6XpliW9Y&usqp=CAU",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        id: 0,
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        id: 0,
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      
      {
        id: 0,
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        id: 0,
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        id: 0,
        name: "Postman",
        image:
          "https://cdn.iconscout.com/icon/free/png-256/free-postman-3521648-2945092.png?f=webp",
      },
      {
        id: 0,
        name: "Figma",
        image:
          "https://w7.pngwing.com/pngs/911/515/png-transparent-figma-logo-brand-logos-brands-in-colors-icon-thumbnail.png",
      },
      {
        id: 0,
        name: "Linux",
        image:
          "https://w7.pngwing.com/pngs/1013/132/png-transparent-linux-distribution-tux-free-software-linux-kernel-linux-logo-bird-linux-thumbnail.png",
      },
      {
        id: 0,
        name: "Virutal Box VM",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCWps6By5L2qbWtcYJYi_bTs7WeyXDVdgHEiAWiFtuGA&s",
      },
      {
        id: 0,
        name: "Gdevelop5",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqXqOEZiZobu0daQFxdPD-_Y0IohMiskUekSqdvPGzzg&s",
      },
      {
        id: 0,
        name: "Unity5",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWRkbdwPXyEDSOeCPhUzSu2tjx9dF8yfBs0QM8_Ig8Zw&s",
      },
    ],
  },
];



export const education = [
  {
    id: 0,
    img: "https://www.iiitd.ac.in/sites/default/files/images/logo/style1colorlarge.png",
    school: "Indraprastha Institute of Information Technology, Delhi",
    date: "Jan 2021 - June 2025",
    grade: "7.5 CGPA (till 6th sem)",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Bioscience at Indraprastha Institute of Information Technology, Delhi. I have completed 6 semesters and have a CGPA of 7.5. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. Apart from ",
    degree: "Bachelor of Technology - BTech, Computer Science and Biosciences",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRyko7kS9vCeD3HubyZ1PRx93qabwlwYmxmr3sJGukOA&s",
    school: "Kendriya Vidyalaya, Shalimar bagh",
    date: "Apr 2019 - Apr 2020",
    grade: "91%",
    desc: "I completed my class 12 high school education at Kendriya Vidyalaya, Shalimar bagh, where I studied Non-Medical(PCM) with Computer Science.",
    Degree: "CBSE Board",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRyko7kS9vCeD3HubyZ1PRx93qabwlwYmxmr3sJGukOA&s",
    school: "Kendriya Vidyalaya, Shalimar bagh",
    date: "Apr 2017 - Apr 2018",
    grade: "90%",
    desc: "I completed my class 10 education at Kendriya Vidyalaya, Shalimar bagh, where I studied Non-Medical(PCM) with Computer Science and physcial Education.",
    Degree: "CBSE Board",
  },
];

export const projects = [
  {
    id: 1,
    title: "VK welding works",
    
    description:
      "Web-based platform that allows users to search, order and contact the businees to fabricate their needs in irons, providing a convenient and efficient solution for new contact lead generation.",
    image: VKweldingProject,
    tags: [
      "MERN stack",
      "tailwind",
      "restapi | CRUD",
    ],
    category: "web app",
    github: "https://github.com/Aniket2021448/VK-welding-works",
    webapp: "https://vkweldingworks.netlify.app/",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
    ]
  },
  
  {
    id: 2,
    title: "MovieMind",
    
    description:
      "This is Content based movie recommendation system, which recommends movies based on the movie story, cast and overview. Trained on 13k movies data from kaggle.",
    image: MovieMind,
    tags: [
      "ML | NLP",
      "Python",
      "Streamlit cloud",
    ],
    category: "machine learning",
    github: "https://github.com/Aniket2021448/Movie-recommender-system",
    webapp: "https://movie-mind.streamlit.app/",
  
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
      {
        name: "Aryan Sharma",
        img: "https://avatars.githubusercontent.com/u/108568470?v=4",
        linkedin: "https://www.linkedin.com/in/aryan21454?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        github: "https://github.com/aryan21454",
      },
    ],
  },

  {
    id: 3,
    title: "Find the fake",
    
    description:
      "This is a streamlit powered web app, which uses logisitic regression based BERT transformers model from hugging face to find the fake news from the given news. The model is trained on 20k news data.",
    image: findFake,
    tags: [
      "BERT",
      "Hugging face",
      "NLP | Classification",
    ],
    category: "machine learning",
    github: "https://github.com/Aniket2021448/FakeNewsPredictionApp",
    webapp: "https://huggingface.co/spaces/GoodML/FindTheFakeNews",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
    ]
  },
  {
    id: 4,
    title: "Comment Feel",
    
    description:
      "This project utilizes a pre-trained sentiment analysis model based on BERT and TensorFlow to analyze the sentiment of comments from a YouTube video using the video-url and determine their sentiments.",
    image: CommentFeel,
    tags: [
      "Sentiments | NLP",
      "Web scrapping",
      "Streamlit",
    ],
    category: "machine learning",
    github: "https://huggingface.co/spaces/GoodML/Comment-Feel/tree/main",
    webapp: "https://huggingface.co/spaces/GoodML/Comment-Feel",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
      {
        name: "Ankit Bisht",
        img: "https://avatars.githubusercontent.com/u/104578922?s=400&v=4",
        linkedin: "https://www.linkedin.com/in/ankit-bisht-197448239/",
        github: "https://github.com/ankitbisht23",
      },
    ],
  },
  {
    id: 5,
    title: "College Chat",
    
    description:
      "This is a real time chat application, created using MERN technologies, along with socket.io functionality to enable the real time chatting experience. Currently in developement phase.",
    image: CollegeChat,
    tags: [
      "MERN stack",
      "socket.io",
      "JWT | security",
      "Render | hosting",
    ],
    category: "web app",
    github: "https://github.com/Aniket2021448/CollegeChat",
    webapp: "https://collegechat.onrender.com/",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
    ]
  },
  {
    id: 6,
    title: "Stat Wizard",
    
    description:
      "Stat Wizard is a web platform that guides users through inferential statistics by using a decision tree approach. Users input specific tasks, and Stat Wizard suggests the appropriate statistical test for their research.",
    image: StatWizard,
    tags: [
      "ReactJS",
      "Statstics",
      "Decision tree",
      "Netlify | hosting",
    ],
    category: "web app",
    github: "https://github.com/Aniket2021448/StatWizard",
    webapp: "https://stalwart-truffle-f21f9a.netlify.app/",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
      {
        name: "Aryan Sharma",
        img: "https://avatars.githubusercontent.com/u/108568470?v=4",
        linkedin: "https://www.linkedin.com/in/aryan21454?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        github: "https://github.com/aryan21454",
      },
      {
        name: "Drashy sesodia",
        img: "https://avatars.githubusercontent.com/u/107747111?v=4",
        linkedin: "https://www.linkedin.com/in/drashy-sesodia-34b51822b/",
        github: "https://github.com/Drew-drashy",
      },
      
    ],
  },

  {
    id: 7,
    title: "Linux Shell",
    
    description:
      "The Custom Linux Shell project is a command-line interpreter implemented in C, designed to mimic essential Linux commands and functionalities. Developed as a core Computer Science mini-project, this shell provides users with a familiar interface to interact with their operating system using commands similar to those found in Unix-based systems.",
    image: linuxShell,
    tags: [
      "Operating system",
      "System calls",
      "C programming",
      "Linux | shell",
    ],
    category: "core CS",
    github: "https://github.com/Aniket2021448/Operating-System/tree/main/Assignment2",
    webapp: "https://replit.com/@AniketPanchal3/assignment2?v=1#externalCommands/OS1.c",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
    ]
  },

  {
    id: 8,
    title: "Taxi.@.IIITD",
    
    description:
      "We made an end to end application for online cab booking system under DBMS course. We tried to implement the functionalities of such CAB booking app, out main focus is to showcase DBMS functionaliteis, properties using HTML, CSS, JAVASCRIPT, BOOTSTRAP for our frontend Django, mySQL for our backend. The project is now under improvement phase which includes improving the security, UI and some other areas as well.",
    image: TaxiATIIITD,
    tags: [
      "Django",
      "mySQL",
      "HTML | CSS",
      "Bootstrap", 
      "DBMS"
    ],
    category: "core CS",
    github: "https://github.com/Aniket2021448/TAXI.at.IIITD",
    webapp: "https://github.com/Aniket2021448/TAXI.at.IIITD",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
      {
        name: "Aryan Sharma",
        img: "https://avatars.githubusercontent.com/u/108568470?v=4",
        linkedin: "https://www.linkedin.com/in/aryan21454?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        github: "https://github.com/aryan21454",
      },
     
      
    ],
  },

  {
    id: 9,
    title: "Omics unveil",
    
    description:
      "The Signature Discovery Using Multi Omics Data Approach in Leukemia using unsupervised learning project is a practical bioinformatics endeavor focused on leveraging unsupervised learning techniques to uncover signatures within multi-omics data associated with leukemia. By integrating gene expression and DNA methylation data from the TCGA-LAML project using R programming, this project aims to unveil distinctive molecular patterns and biological insights relevant to leukemia subtypes.",
    image: OmicsUnveil,
    tags: [
      "R | R studio",
      "Data Analysis",
      "Bioinformatics",
      "Unsupervised learning",
      "K-means clustering",
    ],
    category: "core CS",
    github: "https://github.com/Himanshu21464/PB_Project/",
    webapp: "https://github.com/Himanshu21464/PB_Project/",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
      {
        name: "Himanshu",
        img: "https://avatars.githubusercontent.com/u/98085386?v=4",
        linkedin: "https://www.linkedin.com/in/himanshu-rishabh-b547b1268",
        github: "https://github.com/Himanshu21464",
      },
    ],
  },


  {
    id: 10,
    title: "BioSync",
    
    description:
      "BioSync is a web-based platform that integrates multiple biological databases to provide users with a comprehensive search engine for biological data. By aggregating information from various databases, BioSync enables users to access a wide range of biological data in one place, streamlining the process of data retrieval and integration for researchers and scientists. The project is developed using Django, HTML, CSS, and JavaScript.",
    image: BioSync,
    tags: [
      "Information retrieval",
      "Integration",
      "API",
      "Big data",
      "DBMS",
    ],
    category: "core CS",
    github: "https://github.com/Tanishq-Tiwari-28/IIA_project",
    webapp: "https://github.com/Tanishq-Tiwari-28/IIA_project",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
      {
        name: "Siddhartha Anand",
        img: "https://avatars.githubusercontent.com/u/108649186?v=4",
        linkedin: "https://www.linkedin.com/in/siddharth-anand-36998222b/",
        github: "https://github.com/Sidanand55",
      },
      {
        name: "Tanishq tiwari",
        img: "https://avatars.githubusercontent.com/u/101003432?v=4",
        linkedin: "https://www.linkedin.com/in/tanishq-tiwari-28b562233/",
        github: "https://github.com/Tanishq-Tiwari-28",
      },
      
    ],
  },
  {
    id: 11,
    title: "StockSense AI",
    
    description:
      "A deep learning-powered web app for visualizing historical stock prices and predicting future trends to help users make informed investment decisions.",
    image: stockSenseAI,
    tags: [
      "LSTM",
      "RNN",
      "yahoo-finance | API",
      "Analytics",
      "DBMS",
    ],
    category: "machine learning",
    github: "https://huggingface.co/spaces/GoodML/StockSense/tree/main",
    webapp: "https://huggingface.co/spaces/GoodML/StockSense",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      },
      
    ],
  },

  {
    id: 12,
    title: "MediBotAI",
    
    description:
      "MediBotAI is a chatbot that provides users with information on various medical conditions, symptoms, and treatments. By leveraging NLP, ML, LLM techniques, MediBotAI can understand user queries and provide relevant information in real-time. The chatbot is designed to assist users in accessing medical information quickly and efficiently, making it a valuable resource for individuals seeking health-related information.",
    image: MediBotAI,
    tags: [
      "Python | VS code",
      "LLM",
      "NLP",
      "Hugging face",
      "Pinecone",
    ],
    category: "machine learning",
    github: "https://github.com/Aniket2021448/MediBotIQ",
    webapp: "https://huggingface.co/spaces/GoodML/MediBotAI",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      }
    ]
  },
  {
    id: 13,
    title: "Dish Decode",
    
    description:
      "API endpoint: https://goodml-dishdecode.hf.space \nDishdecode API is the way to get your structured pdf formatted recipe information from your recipe video. It uses deepnovogram API(whisper AI application) to extract the audio transcription along with visual cues from video like text present in it to get a mix of information and using the GEMINI knowledge base to return the structured information which can be used at the frontend to give desired solutions",
    image: DishDecodeAI,
    tags: [
      "Python | VS code",
      "GEMINI LLM",
      "Whisper AI",
      "Hugging face"
    ],
    category: "machine learning",
    github: "https://github.com/Aniket2021448/Dish-Decode",
    webapp: "https://cgasproject-frontend.onrender.com/",
    member: [
      {
        name: "Aniket Panchal",
        img: "https://avatars.githubusercontent.com/u/108399480?v=4",
        linkedin: "https://www.linkedin.com/in/aniket-panchal-0a7b3a233/",
        github: "https://github.com/Aniket2021448",
      }
    ]
  },

  
];



export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];



export const experiences = [
  {
    id: 0,
    img: NatwestLogo,
    role: "Software Engineer",
    company: "Natwest Group",
    date: "July 2025 - Present",
    desc: "",
    skills: [

      "Java backend development",
      "Spring Boot",
      "IBM DB2",
      "Unit & SIT testing",
      "Microservices",
      "Apache Kafka",
      "Code review",
      "Agile methodologies",
      "Gitlab: VCS, CI-CD",
      "Swagger Testing",
      "JIRA/Confluence",

    ]
  },
  {
    id: 1,
    img: NatwestLogo,
    role: "Software Intern",
    company: "Natwest Group",
    date: "May 2024 - July 2024",
    desc: "- Spearheaded microservice development leveraging PostgreSQL JSONB to modernize data storage.\n- Engineered a Java Spring Boot microservice with 30 core features and 4 business-critical processes.\n- Optimized data manipulation and retrieval with PostgreSQL, enhancing the system overall  performance.\n- Developed REST APIs to drive real-time data interaction, aligning with business requirements and setting the foundation for future implementations.",
    skills: [

      "Java backend development",
      "Spring Boot",
      "PostgreSQL",
      "Microservices",
      "Object-oriented programming",
      "Code review",
      "Agile methodologies",
      "API development",
      "Version control",
      "Swagger Testing",
    ],
    doc: NatwestInternCertificate,
  },
  
];
